import { render, staticRenderFns } from "./message.vue?vue&type=template&id=f9933854&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&id=f9933854&prod&lang=less&scoped=true&"
import style1 from "./message.vue?vue&type=style&index=1&id=f9933854&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9933854",
  null
  
)

export default component.exports